import {
  CrossBorderUrlApiInfoResponse,
  ValidateEmployeeOTPResponse,
  VoPayResponse,
  AccountBillingSettingsResponse,
  PartnerAccountUsersChangePasswordResponse,
  ApiResponse,
  AuthorizationResponse,
  PartnerAccountCreationResponse,
  PartnerAccountCreationLinkResponse,
  InvoicePdfResponse,
  PartnerInvoicesResponse,
  PartnerInvoiceDetailsResponse,
  PartnerBillingPackageDetailsResponse,
  PartnerBillingPackagesResponse,
  PartnerCustomPackageResponse,
  PartnerStatementPdfResponse,
  PartnerStatisticsResponse,
  SingleUseTokenResponse,
  TransactionsRefundResponse,
  AccountTransactions,
  DeleteAccountUserResponse,
  CreateAccountUserResponse,
  FetchAccountUsersApiResponse,
  FetchPartnerAccountUsersApiResponse,
  IQ11AuthorizationResponse,
  IQ11EmbedUrlResponse,
  IQ11TokenResponse,
  CreditCardResponse,
  BankAccountsResponse,
  SetMyBankAccountResponse,
  SetMyCreditCardResponse,
  AccountUserPermissionsResponse,
  GetTransactionCountsResponse,
  InteracEmailResponse,
  SetClientEmailResponse,
  GetDebitCardsApiResponse,
  GenerateEmployeeOTPResponse,
} from './VoPayApi.types';

export function verifyResponseType<T>(endpoint: string, actual: unknown, expected: VoPayResponse[]): T {
  const handlers: { [key in VoPayResponse]: () => boolean } = {
    ValidateEmployeeOTPResponse: () => isValidateEmployeeOTPResponse(actual),
    GenerateEmployeeOTPResponse: () => isGenerateEmployeeOTPResponseResponse(actual),
    CrossBorderUrlApiInfoResponse: () => isCrossBorderUrlApiInfoResponse(actual),
    FetchDomainApiResponse: () => isDomainResponse(actual),
    AddDomainResponse: () => isDomainResponse(actual),
    VerifyDomainResponse: () => isDomainResponse(actual),
    DeleteDomainResponse: () => isApiResponse(actual),
    LinkGooglePayResponse: () => isApiResponse(actual),
    AccountBillingSettingsResponse: () => isAccountBillingSettingsResponse(actual),
    AccountTransactions: () => isAccountTransactions(actual),
    AccountUsers: () => isAccountUsers(actual),
    AccountUserPermissionsResponse: () => isAccountUserPermissions(actual),
    AccountUsersChangePasswordResponse: () => isAccountUsersChangePasswordResponse(actual),
    ApiResponse: () => isApiResponse(actual),
    AuthorizationResponse: () => isAuthorizationResponse(actual),
    CreateAccountUserResponse: () => isCreateAccountUserResponse(actual),
    CreditCardTransactionResponse: () => isCreditCardTransactionsResponse(),
    DeleteAccountUserResponse: () => isDeleteAccountUserResponse(actual),
    EftFundingTransactionResponse: () => isEftFundingTransactionResponse(),
    EftWithdrawTransactionResponse: () => isEftWithdrawTransactionResponse(),
    InteracBulkPayoutTransactionResponse: () => isInteracBulkPayoutTransactionsResponse(),
    InteracTransactionResponse: () => isInteracTransactionsResponse(),
    RTRWithdrawTransactionResponse: () => isRTRWithdrawTransactionResponse(),
    PortalDocumentResponse: () => true,
    PortalVideoResponse: () => true,
    PartnerAccountUsersChangePasswordResponse: () => isPartnerAccountUsersChangePasswordResponse(actual),
    PartnerAccountCreationResponse: () => isPartnerAccountCreationResponse(actual),
    PartnerAccountCreationLinkResponse: () => isPartnerAccountCreationLinkResponse(actual),
    PartnerInvoiceDetailsResponse: () => isPartnerInvoiceDetailsResponse(actual),
    PartnerBillingSettingsDetailsResponse: () => isPartnerBillingSettingsDetailsResponse(actual),
    PartnerBillingPackageDetailsResponse: () => isPartnerBillingPackageDetailsResponse(actual),
    PartnerBillingPackagesResponse: () => isPartnerBillingPackagesResponse(actual),
    PartnerCustomPackageResponse: () => isPartnerCustomPackageResponse(actual),
    PartnerInvoicePdfResponse: () => isPartnerInvoicePdfResponse(actual),
    PartnerInvoicesResponse: () => isPartnerInvoicesResponse(actual),
    PartnerStatementPdfResponse: () => isPartnerStatementPdfResponse(actual),
    PartnerStatisticsResponse: () => isPartnerStatisticsResponse(actual),
    SingleUseTokenResponse: () => isSingleUseTokenResponse(actual),
    TransactionsRefundResponse: () => isTransactionsRefundResponse(actual),
    PartnerUsersResponse: () => isPartnerUsersResponse(actual),
    IQ11AuthorizationResponse: () => isIQ11AuthorizationResponse(actual),
    IQ11EmbedUrlResponse: () => isIQ11IQ11EmbedUrlResponse(actual),
    GlobalPayTokenResponse: () => isGlobalPayTokenResponse(),
    IQ11TokenResponse: () => isIQ11TokenResponse(actual),
    CreditCardResponse: () => isCreditCardResponse(actual),
    BankAccountsResponse: () => isBankAccountsResponse(actual),
    SetMyBankAccountResponse: () => isSetMyBankAccountResponse(actual),
    SetMyCreditCardResponse: () => isSetMyCreditCardResponse(actual),
    ELinxSingleUseTokenResponse: () => isELinxSingleUseTokenResponse(),
    ClientAuthorizationResponse: () => isClientAuthorizationResponse(),
    TicketCategoriesResponse: () => isTicketCategoriesResponse(),
    HubSpotDropdownDataResponse: () => isHubSpotDropdownDataResponse(),
    HubSpotDealDetailsResponse: () => isHubSpotDealDetailsResponse(),
    DocumentUploadResponse: () => isDocumentUploadResponse(),
    AccessTokenInfoResponse: () => isAccessTokenInfoResponse(),
    PushToCardMapResponse: () => isPushToCardMapResponse(),
    OnboardingAppTokenResponse: () => isOnboardingAppTokenResponse(),
    AssignedBillingPackagesResponse: () => isAssignedBillingPackagesResponse(),
    GeoLocationResponse: () => isGeolocationResponse(),
    MyBankAccountResponse: () => isMyBankAccountResponse(),
    OnboardingAccountBillingResponse: () => isOnboardingAccountBillingResponse(),
    OnboardingAccountBillingDocumentResponse: () => isOnboardingAccountBillingDocumentResponse(),
    AccountBillingDetailsResponse: () => isAccountBillingDetailsResponse(),
    SetMyBankAccountPurposeResponse: () => isSetMyBankAccountPurposeResponse(),
    AccountDocumentResponse: () => isAccountDocumentResponse(),
    DebitAuthorityAgreementResponse: () => isDebitAuthorityAgreementResponse(),
    AccountTransactionTypesResponse: () => isAccountTransactionTypesResponse(),
    OnboardingAppUrlResponse: () => isOnboardingAppUrlResponse(),
    UploadFileAttachmentResponse: () => isUploadFileAttachmentResponse(),
    AccountBillingSavePaymentInformationResponse: () => isAccountBillingSavePaymentInformationResponse(),
    RetriggerWebhookResponse: () => isRetriggerWebhookResponse(),
    GetTransactionCountsResponse: () => isGetTransactionCountsResponse(actual),
    InteracEmailResponse: () => isInteracEmailResponse(actual),
    SetClientEmailResponse: () => isSetClientEmailResponse(actual),
    GetDebitCardsApiResponse: () => isGetDebitCardsApiResponse(actual),
    SetMyGooglePayResponse: () => isSetMyGooglePayResponse(actual),
    SetMyApplePayResponse: () => isSetMyApplePayResponse(actual),
    SetMyPayPalResponse: () => isSetMyPayPalResponse(actual),
    SetMyVenmoResponse: () => isSetMyVenmoResponse(actual),
    FileConversionHistoryResponse: () => isApiResponse(actual),
    FileConversionDownloadResponse: () => isApiResponse(actual),
  };

  if (!expected.some((possibleResType) => handlers[possibleResType]())) {
    console.warn(`Did not receive the expected response type from ${endpoint}`);
  }

  return actual as T;
}

function isValidateEmployeeOTPResponse(res: unknown): res is ValidateEmployeeOTPResponse {
  if (isApiResponse(res) && res.Success) {
    return Object.prototype.hasOwnProperty.call(res, 'Token');
  }

  return isApiResponse(res);
}

function isGenerateEmployeeOTPResponseResponse(res: unknown): res is GenerateEmployeeOTPResponse {
  if (isApiResponse(res) && res.Success) {
    return Object.prototype.hasOwnProperty.call(res, 'Token');
  }

  return isApiResponse(res);
}

function isGetTransactionCountsResponse(res: unknown): res is GetTransactionCountsResponse {
  if (isApiResponse(res) && res.Success) {
    return Object.prototype.hasOwnProperty.call(res, 'CountData');
  }

  return isApiResponse(res);
}

// TODO: verification of the response to be implemented
function isEftFundingTransactionResponse() {
  return true;
}
// TODO: verification of the response to be implemented
function isEftWithdrawTransactionResponse() {
  return true;
}
// TODO: verification of the response to be implemented
function isInteracTransactionsResponse() {
  return true;
}
function isRTRWithdrawTransactionResponse() {
  return true;
}
// TODO: verification of the response to be implemented
function isInteracBulkPayoutTransactionsResponse() {
  return true;
}
// TODO: verification of the response to be implemented
function isCreditCardTransactionsResponse() {
  return true;
}
function isELinxSingleUseTokenResponse() {
  return true;
}

function isCrossBorderUrlApiInfoResponse(res: unknown): res is CrossBorderUrlApiInfoResponse {
  return (
    isApiResponse(res) &&
    Object.prototype.hasOwnProperty.call(res, 'JWT') &&
    Object.prototype.hasOwnProperty.call(res, 'ClientAccountID')
  );
}

function isDomainResponse(res: unknown): res is { Domain: string } {
  if (isApiResponse(res) && res.Success) {
    return Object.prototype.hasOwnProperty.call(res, 'Domain');
  }

  return isApiResponse(res);
}

function isPartnerUsersResponse(res: unknown): res is FetchPartnerAccountUsersApiResponse {
  const hasUsers = Object.prototype.hasOwnProperty.call(res, 'Users');
  return [hasUsers].every((condition) => condition);
}
function isAccountBillingSettingsResponse(res: unknown): res is AccountBillingSettingsResponse {
  if (isSuccess(res) && hasBillingSettings(res)) {
    if (Object.keys(res.BillingSettings).length === 0) return true;
    if (!res.BillingSettings[0]) return false;

    const hasID = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'ID');
    const hasPackageName = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'PackageName');
    const hasIsActive = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'IsActive');
    const hasCurrency = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'Currency');
    const hasStartDate = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'StartDate');
    const hasEndDate = Object.prototype.hasOwnProperty.call(res.BillingSettings[0], 'EndDate');

    return [hasID, hasPackageName, hasIsActive, hasCurrency, hasStartDate, hasEndDate].every((condition) => condition);
  }

  return isError(res);

  function hasBillingSettings(_res: unknown): _res is { BillingSettings: { [idx: string]: unknown } } {
    return Object.prototype.hasOwnProperty.call(res, 'BillingSettings');
  }
}

function isAccountUsersChangePasswordResponse(res: unknown): res is PartnerAccountUsersChangePasswordResponse {
  const hasUsername = Object.prototype.hasOwnProperty.call(res, 'Username');
  return (isError(res) && !hasUsername) || (isSuccess(res) && [hasUsername].every((condition) => condition));
}

function isPartnerAccountUsersChangePasswordResponse(res: unknown): res is PartnerAccountUsersChangePasswordResponse {
  const hasUsername = Object.prototype.hasOwnProperty.call(res, 'Username');
  return (isError(res) && !hasUsername) || (isSuccess(res) && [hasUsername].every((condition) => condition));
}

function isApiResponse(res: unknown): res is ApiResponse {
  const hasSuccess = Object.prototype.hasOwnProperty.call(res, 'Success');
  const hasErrorMessage = Object.prototype.hasOwnProperty.call(res, 'ErrorMessage');

  return [hasSuccess, hasErrorMessage].some((condition) => condition);
}

function isAuthorizationResponse(res: unknown): res is AuthorizationResponse {
  const hasAccountID = Object.prototype.hasOwnProperty.call(res, 'AccountID');
  const hasName = Object.prototype.hasOwnProperty.call(res, 'Name');
  const hasPartnerType = Object.prototype.hasOwnProperty.call(res, 'PartnerType');
  const hasPermissions = Object.prototype.hasOwnProperty.call(res, 'Permissions');

  const hasAuthorization =
    isSuccess(res) && [hasAccountID, hasName, hasPartnerType, hasPermissions].every((condition) => condition);

  return hasAuthorization || isError(res);
}

function isIQ11AuthorizationResponse(res: unknown): res is IQ11AuthorizationResponse {
  const hasClientAccount = Object.prototype.hasOwnProperty.call(res, 'ClientAccount');
  const hasJWT = Object.prototype.hasOwnProperty.call(res, 'JWT');

  const hasAuthorization = isSuccess(res) && [hasClientAccount, hasJWT].every((condition) => condition);

  return hasAuthorization || isError(res);
}

function isIQ11IQ11EmbedUrlResponse(res: unknown): res is IQ11EmbedUrlResponse {
  const hasEmbedURL = Object.prototype.hasOwnProperty.call(res, 'EmbedURL');
  return (isError(res) && !hasEmbedURL) || (isSuccess(res) && [hasEmbedURL].every((condition) => condition));
}

function isPartnerAccountCreationResponse(res: unknown): res is PartnerAccountCreationResponse {
  const hasMessage = Object.prototype.hasOwnProperty.call(res, 'Message');
  const hasAccountID = Object.prototype.hasOwnProperty.call(res, 'AccountID');
  const hasSecret = Object.prototype.hasOwnProperty.call(res, 'APISharedSecret');
  const hasKey = Object.prototype.hasOwnProperty.call(res, 'APIKey');

  const hasCreatedAccount =
    isSuccess(res) && [hasMessage, hasAccountID, hasSecret, hasKey].every((condition) => condition);

  return hasCreatedAccount || isError(res);
}

function isPartnerAccountCreationLinkResponse(res: unknown): res is PartnerAccountCreationLinkResponse {
  const isResponse = isPartnerAccountCreationResponse(res);
  const hasLink = Object.prototype.hasOwnProperty.call(res, 'Link');

  return isResponse && hasLink;
}

function isPartnerInvoiceDetailsResponse(res: unknown): res is PartnerInvoiceDetailsResponse {
  const hasInvoiceDetails = Object.prototype.hasOwnProperty.call(res, 'InvoiceDetails');
  const hasInvoicePeriod = Object.prototype.hasOwnProperty.call(res, 'InvoicePeriod');

  const hasInvoiceData = isSuccess(res) && [hasInvoiceDetails, hasInvoicePeriod].every((condition) => condition);

  return (isError(res) && !hasInvoiceData) || [isSuccess(res), hasInvoiceData].every((condition) => condition);
}

function isPartnerInvoicePdfResponse(res: unknown): res is InvoicePdfResponse {
  const hasInvoiceID = Object.prototype.hasOwnProperty.call(res, 'InvoicePDF');
  const hasInvoiceData = isSuccess(res) && [hasInvoiceID].every((condition) => condition);

  return (isError(res) && !hasInvoiceData) || hasInvoiceData;
}

function isPartnerStatementPdfResponse(res: unknown): res is PartnerStatementPdfResponse {
  const hasStatementCsv = Object.prototype.hasOwnProperty.call(res, 'StatementPDF');
  const hasInvoiceData = isSuccess(res) && [hasStatementCsv].every((condition) => condition);

  return (isError(res) && !hasInvoiceData) || hasInvoiceData;
}

function isPartnerInvoicesResponse(res: unknown): res is PartnerInvoicesResponse {
  const hasPartnerInvoices = Object.prototype.hasOwnProperty.call(res, 'PartnerInvoices');
  const hasInvoiceData = isSuccess(res) && [hasPartnerInvoices].every((condition) => condition);

  return (isError(res) && !hasInvoiceData) || hasInvoiceData;
}

function isPartnerBillingSettingsDetailsResponse(res: unknown): res is PartnerBillingPackageDetailsResponse {
  const hasSettingsDetails = Object.prototype.hasOwnProperty.call(res, 'SettingsDetails');

  return (isError(res) && !hasSettingsDetails) || [isSuccess(res), hasSettingsDetails].every((condition) => condition);
}

function isPartnerBillingPackageDetailsResponse(res: unknown): res is PartnerBillingPackageDetailsResponse {
  const hasPackageDetails = Object.prototype.hasOwnProperty.call(res, 'PackageDetails');

  return (isError(res) && !hasPackageDetails) || [isSuccess(res), hasPackageDetails].every((condition) => condition);
}

function isPartnerBillingPackagesResponse(res: unknown): res is PartnerBillingPackagesResponse {
  const hasBillingPackages = Object.prototype.hasOwnProperty.call(res, 'BillingPackages');

  return (isError(res) && !hasBillingPackages) || [isSuccess(res), hasBillingPackages].every((condition) => condition);
}

function isPartnerCustomPackageResponse(res: unknown): res is PartnerCustomPackageResponse {
  const hasApprovalProperty = Object.prototype.hasOwnProperty.call(res, 'IsApproved');

  return (
    (isError(res) && !hasApprovalProperty) || [isSuccess(res), hasApprovalProperty].every((condition) => condition)
  );
}

function isPartnerStatisticsResponse(res: unknown): res is PartnerStatisticsResponse {
  const hasStatistics = Object.prototype.hasOwnProperty.call(res, 'Statistics');

  return (isError(res) && !hasStatistics) || [isSuccess(res), hasStatistics].every((condition) => condition);
}

function isSingleUseTokenResponse(res: unknown): res is SingleUseTokenResponse {
  const hasToken = Object.prototype.hasOwnProperty.call(res, 'Token');
  const hasIsValidToken = Object.prototype.hasOwnProperty.call(res, 'IsValidToken');

  const hasSingleUseToken = isSuccess(res) && [hasToken, hasIsValidToken].every((condition) => condition);

  return (isError(res) && !hasSingleUseToken) || [isSuccess(res), hasSingleUseToken].every((condition) => condition);
}

function isTransactionsRefundResponse(res: unknown): res is TransactionsRefundResponse {
  const hasTransactionID = Object.prototype.hasOwnProperty.call(res, 'TransactionID');

  return (isError(res) && !hasTransactionID) || [isSuccess(res), hasTransactionID].every((condition) => condition);
}

function isAccountTransactions(res: unknown): res is AccountTransactions {
  const hasTransactions = Object.prototype.hasOwnProperty.call(res, 'Transactions');
  const hasCSVFile = Object.prototype.hasOwnProperty.call(res, 'CSVFile');
  const hasPDFFile = Object.prototype.hasOwnProperty.call(res, 'PDFFile');
  const hasCSVFileOrHasTransactions = hasTransactions || hasCSVFile || hasPDFFile;
  return (
    (isError(res) && !hasTransactions) || [isSuccess(res), hasCSVFileOrHasTransactions].every((condition) => condition)
  );
}
function isDeleteAccountUserResponse(res: unknown): res is DeleteAccountUserResponse {
  const hasUserID = Object.prototype.hasOwnProperty.call(res, 'UserID');
  const hasIsActive = Object.prototype.hasOwnProperty.call(res, 'IsActive');
  const hasUserIDAndHasIsActive = hasUserID && hasIsActive;
  return (
    (isError(res) && !hasUserIDAndHasIsActive) ||
    [isSuccess(res), hasUserIDAndHasIsActive].every((condition) => condition)
  );
}
function isCreateAccountUserResponse(res: unknown): res is CreateAccountUserResponse {
  const hasUsername = Object.prototype.hasOwnProperty.call(res, 'Username');
  return (isError(res) && !hasUsername) || (isSuccess(res) && [hasUsername].every((condition) => condition));
}
function isAccountUsers(res: unknown): res is FetchAccountUsersApiResponse {
  const hasUsers = Object.prototype.hasOwnProperty.call(res, 'Users');
  return (isError(res) && !hasUsers) || (isSuccess(res) && [hasUsers].every((condition) => condition));
}

function isAccountUserPermissions(res: unknown): res is AccountUserPermissionsResponse {
  const hasUsername = Object.prototype.hasOwnProperty.call(res, 'Username');
  const hasPermissions = Object.prototype.hasOwnProperty.call(res, 'Permissions');
  const hashasUsernameAndHasPermissions = hasUsername && hasPermissions;
  return (
    (isError(res) && !hashasUsernameAndHasPermissions) ||
    [isSuccess(res), hashasUsernameAndHasPermissions].every((condition) => condition)
  );
}

function isInteracEmailResponse(res: unknown): res is InteracEmailResponse {
  const hasEmails = Object.prototype.hasOwnProperty.call(res, 'InteracEmails');

  return isError(res) || (isSuccess(res) && hasEmails);
}

function isError(res: unknown): boolean {
  const hasErrorMessage = Object.prototype.hasOwnProperty.call(res, 'ErrorMessage');

  return isApiResponse(res) && !res.Success && res.ErrorMessage !== '' && hasErrorMessage;
}
function isSuccess(res: unknown): boolean {
  return isApiResponse(res) && res.Success && !res.ErrorMessage;
}

function isGlobalPayTokenResponse() {
  return true;
}

function isIQ11TokenResponse(res: unknown): res is IQ11TokenResponse {
  const hasToken = Object.prototype.hasOwnProperty.call(res, 'Token');
  return (isError(res) && !hasToken) || (isSuccess(res) && [hasToken].every((condition) => condition));
}

function isCreditCardResponse(res: unknown): res is CreditCardResponse {
  const hasCreditCards = Object.prototype.hasOwnProperty.call(res, 'CreditCards');

  const hasCreditCardsData = isSuccess(res) && [hasCreditCards].every((condition) => condition);

  return (isError(res) && !hasCreditCardsData) || [isSuccess(res), hasCreditCardsData].every((condition) => condition);
}

function isBankAccountsResponse(res: unknown): res is BankAccountsResponse {
  const hasBankAccounts = Object.prototype.hasOwnProperty.call(res, 'BankAccounts');

  return (isError(res) && !hasBankAccounts) || (isSuccess(res) && [hasBankAccounts].every((condition) => condition));
}

function isSetMyBankAccountResponse(res: unknown): res is SetMyBankAccountResponse {
  const hasToken = Object.prototype.hasOwnProperty.call(res, 'CreditCardToken');
  const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');

  return (isError(res) && !hasToken) || [isSuccess(res), hasIsDefault].every((condition) => condition);
}

function isSetMyCreditCardResponse(res: unknown): res is SetMyCreditCardResponse {
  const hasToken = Object.prototype.hasOwnProperty.call(res, 'CreditCardToken');
  const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');

  return (isError(res) && !hasToken) || [isSuccess(res), hasIsDefault].every((condition) => condition);
}

function isSetClientEmailResponse(res: unknown): res is SetClientEmailResponse {
  const hasToken = Object.prototype.hasOwnProperty.call(res, 'Token');
  const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');

  return isError(res) || [isSuccess(res), hasToken, hasIsDefault].every((isValid) => isValid);
}

function isGetDebitCardsApiResponse(res: unknown): res is GetDebitCardsApiResponse {
  const hasDebitCards = Object.prototype.hasOwnProperty.call(res, 'DebitCards');

  return isError(res) || (isSuccess(res) && hasDebitCards);
}

function isGeolocationResponse() {
  return true;
}

function isClientAuthorizationResponse() {
  return true;
}
function isTicketCategoriesResponse() {
  return true;
}

function isHubSpotDropdownDataResponse() {
  return true;
}
function isHubSpotDealDetailsResponse() {
  return true;
}

function isDocumentUploadResponse() {
  return true;
}

function isAccessTokenInfoResponse() {
  return true;
}

function isPushToCardMapResponse() {
  return true;
}

function isOnboardingAppTokenResponse() {
  return true;
}

function isAssignedBillingPackagesResponse() {
  return true;
}

function isMyBankAccountResponse() {
  return true;
}

function isOnboardingAccountBillingResponse() {
  return true;
}

function isOnboardingAccountBillingDocumentResponse() {
  return true;
}

function isAccountBillingDetailsResponse() {
  return true;
}

function isSetMyBankAccountPurposeResponse() {
  return true;
}

function isAccountDocumentResponse() {
  return true;
}

function isDebitAuthorityAgreementResponse() {
  return true;
}

function isAccountTransactionTypesResponse() {
  return true;
}

function isOnboardingAppUrlResponse() {
  return true;
}

function isUploadFileAttachmentResponse() {
  return true;
}

function isAccountBillingSavePaymentInformationResponse() {
  return true;
}

function isSetMyGooglePayResponse(res: unknown): res is { GooglePayToken: string; IsDefault: boolean } {
  if (isApiResponse(res) && res.Success) {
    const hasGooglePayToken = Object.prototype.hasOwnProperty.call(res, 'GooglePayToken');
    const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');
    return hasGooglePayToken && hasIsDefault;
  }
  return isApiResponse(res);
}

function isSetMyApplePayResponse(res: unknown): res is { ApplePayToken: string; IsDefault: boolean } {
  if (isApiResponse(res) && res.Success) {
    const hasApplePayToken = Object.prototype.hasOwnProperty.call(res, 'ApplePayToken');
    const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');
    return hasApplePayToken && hasIsDefault;
  }
  return isApiResponse(res);
}

function isSetMyPayPalResponse(res: unknown): res is { PayPalToken: string; IsDefault: boolean } {
  if (isApiResponse(res) && res.Success) {
    const hasPayPalToken = Object.prototype.hasOwnProperty.call(res, 'PayPalToken');
    const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');
    return hasPayPalToken && hasIsDefault;
  }
  return isApiResponse(res);
}

function isSetMyVenmoResponse(res: unknown): res is { VenmoToken: string; IsDefault: boolean } {
  if (isApiResponse(res) && res.Success) {
    const hasVenmoToken = Object.prototype.hasOwnProperty.call(res, 'VenmoToken');
    const hasIsDefault = Object.prototype.hasOwnProperty.call(res, 'IsDefault');
    return hasVenmoToken && hasIsDefault;
  }
  return isApiResponse(res);
}
function isRetriggerWebhookResponse() {
  return true;
}
